import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../../../../utils/Translate';
import TextInput from '../../TextInput/TextInput';
import HtmlMessage from '../../HtmlMessage/HtmlMessage';
import { EmailStore } from '../../../../state/EmailStore';

import './VerifyEmail.css';
import verifyIllus from '../../../../assets/images/verify-illus.svg';
import { PersonalInfoStore } from '../../../../state/PersonalInfoStore';

const VerifyEmail = ({
  digits,
  statusIsLoading,
  statusSecondInputIsEnabled,
  onCodeInputChange,
  onSecondCodeInputChange,
  hints,
  errorMessage
}) => {
  const maxLength = 3;

  return (
    <div className="VerifyEmail -pb-3 -pr-1 -pl-1">
      <div className="left-column">
        <div className=" -mt-lg-1 -mt-sm-3 -fs-2 -lh-3">
          <div className="-eva-3-mb-xxlg">
            {Translate.message('verify-email.codeSent.title')}
          </div>
          <HtmlMessage
            message={
              Translate.message(
                'verify-email.codeSent.primaryEmail.body',
                { email: PersonalInfoStore.getPrimaryEmail() || '' },
              )
            }
          />
        </div>
        <div className="verify-code-container -eva-3-mb-xxlg">
          <TextInput
            title={Translate.message('verify-email.codeSent.input.title')}
            titleClassName="-eva-3-bold -fs-1-v2 -lh-1"
            name="code"
            className="-mt-2"
            onChange={onCodeInputChange}
            disabled={statusIsLoading}
            valid={digits.primaryEmailValid}
            errorMessage={errorMessage}
            value={digits.primaryEmailValue}
            autoComplete={false}
            maxLength={maxLength}
          />
          <div className="code-hint">{hints.primaryEmailTicketHint}</div>
        </div>

        <div className={!statusSecondInputIsEnabled ? '-disabled -eva-3-mt-xxlg -fs-2 -lh-3' : '-enabled -eva-3-mt-xxlg -fs-2 -lh-3'}>
          <HtmlMessage
            message={
              Translate.message(
                'verify-email.codeSent.mergeableEmail.body',
                { email: EmailStore.getMergeableEmail() || '' },
              )
            }
          />
        </div>
        <div className="verify-code-container">
          <TextInput
            title={Translate.message('verify-email.codeSent.input.title')}
            titleClassName="-eva-3-bold -fs-1-v2 -lh-1"
            name="code"
            className="-mt-2"
            onChange={onSecondCodeInputChange}
            disabled={!statusSecondInputIsEnabled}
            valid={digits.secondaryEmailValid}
            errorMessage={errorMessage}
            value={digits.secondaryEmailValue}
            autoComplete={false}
            maxLength={maxLength}
          />
          <div className="code-hint">{hints.emailTicketHint}</div>
        </div>
      </div>
      <div>
        <img className="img-illus -eva-3-fr -eva-3-mt-xxlg" src={`${verifyIllus}`} alt="email" title="email"/>
      </div>
    </div>
  );
};


VerifyEmail.propTypes = {
  digits: PropTypes.shape().isRequired,
  statusIsLoading: PropTypes.bool.isRequired,
  statusSecondInputIsEnabled: PropTypes.bool.isRequired,
  onCodeInputChange: PropTypes.func.isRequired,
  onSecondCodeInputChange: PropTypes.func.isRequired,
  hints: PropTypes.shape().isRequired,
  errorMessage: PropTypes.string.isRequired
};

export default VerifyEmail;
